import { render, staticRenderFns } from "./VendorMember.vue?vue&type=template&id=52ba673c"
import script from "./VendorMember.vue?vue&type=script&lang=js"
export * from "./VendorMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports